// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA7N0yNyJiVhlpBEs5USiaxwwSlBiwXlsQ",
    authDomain: "utility-axis-467512-u1.firebaseapp.com",
    projectId: "utility-axis-467512-u1",
    storageBucket: "utility-axis-467512-u1.firebasestorage.app",
    messagingSenderId: "855081207054",
    appId: "1:855081207054:web:885cd22b236cd813a1435f",
    measurementId: "G-RTFBPVYVZH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, analytics, auth, storage };
